import { HttpService } from './HttpService';

export class UploadService extends HttpService {

    constructor(url: string) {
        super(url);
    }

    public upload(file: any, path: string) {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.set("file", file);
            this.post(path, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((result: any) => {
                if (result.data.error) {
                    console.error("Upload Error:", result.data.error)

                    reject({
                        errorMessage: result.data.error
                    });
                }
                resolve();
            }).catch((error) => {

                console.error("Upload Error:", error)

                reject({
                    errorMessage: "Error during upload request"
                });
            });
        });
    }
}
